// ===== GSAP helper + animations (unchanged) =====
function animateGSAP(selector, fromProps, toProps, extra = {}) {
  gsap.utils.toArray(selector).forEach(function (element) {
    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: element,
        start: "top 95%",
        end: "bottom 50%",
        toggleActions: "play none none none",
        ...extra,
      },
    });
    tl.fromTo(element, fromProps, toProps);
  });
}
animateGSAP("[fade-in-anim]", { opacity: 0, yPercent: 20 }, { duration: 0.5, opacity: 1, yPercent: 0, ease: "cubic" });

// ===== Lenis: keep instance but disable smoothing (native-like scroll) =====
$(document).ready(function () {
  try {
    if (typeof Lenis !== 'undefined') {
      // Create or replace global lenis with smoothing disabled
      // Use conservative options to avoid any inertia/smoothing behavior
      window.lenis = new Lenis({
        // disable all smoothing features
        smooth: false,
        smoothWheel: false,
        smoothTouch: false,
        duration: 0,
      });

      // Remove Lenis "smooth" classes if present so CSS won't apply smooth styles
      document.documentElement.classList.remove('lenis-smooth');
      document.documentElement.classList.remove('lenis--smooth'); // defensive
      // Optionally add a marker class to indicate native-mode (purely cosmetic)
      document.documentElement.classList.add('lenis-native');

      // Prevent the raf loop from doing anything that alters scroll.
      // Some implementations rely on calling lenis.raf in a loop.
      // Overriding it to a no-op ensures it won't change native scrolling.
      if (window.lenis && typeof window.lenis.raf === 'function') {
        try {
          window.lenis.raf = function () { /* no-op to keep native scroll */ };
        } catch (e) {
          // ignore - best-effort
        }
      }

      // Defensive destroy if some other script already started a live instance
      try {
        if (window.lenis && typeof window.lenis.destroy === 'function') {
          // Destroy then re-create inert instance to avoid leftover behavior
          window.lenis.destroy();
          window.lenis = new Lenis({
            smooth: false,
            smoothWheel: false,
            smoothTouch: false,
            duration: 0,
          });
          window.lenis.raf = function () {};
        }
      } catch (e) { /* ignore */ }
    } else {
      // Lenis not present — nothing to do
      // this keeps rest of code working normally
    }
  } catch (err) {
    // Defensive: do not break the page if Lenis isn't available or errors occur
    console.warn('Lenis native-mode init error:', err);
  }
});

// ===== Megamenu logic (unchanged) =====
$(function () {
  const $trigger = $("li#Shop-all");
  const $menu = $(".megamenu-outline");
  let hideTimeout;

  function showMenu() {
    clearTimeout(hideTimeout);
    $menu.addClass("active");
  }

  function hideMenu() {
    hideTimeout = setTimeout(() => {
      if (!$trigger.is(":hover") && !$menu.is(":hover")) {
        $menu.removeClass("active");
      }
    }, 1000); // wait 1s after leaving both areas
  }

  $trigger.on("mouseenter", showMenu);
  $trigger.on("mouseleave", hideMenu);
  $menu.on("mouseenter", showMenu);
  $menu.on("mouseleave", hideMenu);
});
